/**
 * Couche "geologie" : entites hydrogeologiques affleurantes (BD LISA v3),
 * drapees sur le relief.
 *
 * Partage entre le viewer de production (TerrainViewer) et le bac a sable
 * (terrain_test/TerrainTestPage).
 *
 * CE QUI A CHANGE, ET POURQUOI C'EST LE POINT IMPORTANT. Le raster portait
 * jusqu'ici une CLASSE DE COULEUR figee au moment de la generation : la
 * carte ne pouvait montrer qu'un seul classement, celui choisi dans le
 * pipeline. Or BD LISA classe chaque entite selon quatre axes independants,
 * qui repondent a quatre questions differentes :
 *
 *   theme   — de quelle formation s'agit-il (alluvial, sedimentaire, socle) ?
 *   nature  — y a-t-il de l'eau ? (`est_aquifere`) Une unite semi-permeable
 *             ou impermeable n'est pas une ressource : elle joue le role
 *             inverse, celui de couverture protectrice.
 *   milieu  — comment circule-t-elle ? (`karstique`) Le karst court-circuite
 *             la filtration : l'eau y va vite et arrive peu filtree.
 *   etat    — est-elle protegee ? (`nappe_libre`) Une nappe libre est
 *             directement alimentee depuis la surface, donc exposee a ce qui
 *             s'y passe.
 *
 * Le raster porte desormais un INDEX D'ENTITE (Uint16, exactement comme les
 * communes) et geology.json embarque, pour chaque entite, ses quatre
 * classements plus la description de ce qui est cartographiable. Les quatre
 * lectures deviennent quatre colorations d'un meme fichier, obtenues par
 * simple lookup — aucun telechargement ni geometrie supplementaires.
 *
 * Ce module ne porte donc que les constantes de rendu : la selection de
 * l'indicateur, la legende et les couleurs sont assurees par
 * indicatorEngine.js, comme pour les communes.
 */

export const GEOLOGY_NODATA = 65535;

// Decollage de la nappe au-dessus du terrain, en unites de scene et APRES
// exageration. La geologie est la plus basse des nappes drapees (climat a
// +28, communes a +32, limites communales a +52) : c'est un fond de carte,
// elle passe donc sous les couches thematiques.
export const GEOLOGY_Y_OFFSET = 18;

// Assez opaque pour que les aplats se lisent comme un fond de carte, mais
// pas au point d'effacer l'ombrage du relief qui est dessous.
export const GEOLOGY_DEFAULT_OPACITY = 0.8;
export const GEOLOGY_MIN_OPACITY = 0.1;
export const GEOLOGY_MAX_OPACITY = 1;

/**
 * Entite geologique sous une cellule du raster, ou null hors couverture.
 * Sert a la fiche affichee au survol : c'est la seule lecture qui donne le
 * libelle complet de l'entite et sa place dans la hierarchie BD LISA.
 */
export function geologyEntityAt(codes, entities, index) {
  if (!codes || !entities || index == null || index < 0 || index >= codes.length) return null;
  const id = codes[index];
  if (id === GEOLOGY_NODATA) return null;
  return entities[id] || null;
}
